import wwwApconCom from '../www.apcon.com';

const technologies = [
  {
    id: 1,
    title: 'Application Filtering',
    description:
      'Identifies and controls network traffic based on specific applications.',
    icon: 'tabler:filter-cog',
    url: wwwApconCom.technologies.applicationFiltering,
    category: 'intel',
  },
  {
    id: 2,
    title: 'Deep Packet Inspection',
    description:
      "Enhance your network's speed and monitoring capabilities, increase your security tools' effectiveness, and lower data storage costs by removing duplicate packets.",
    icon: 'mdi:magnify-expand',
    url: wwwApconCom.technologies.deepPacketInspection,
    category: 'intel',
  },
  {
    id: 3,
    title: 'Traffic Shaping',
    description:
      'Controls the flow of network data to optimize bandwidth and reduce congestion.',
    icon: 'mdi:trending-down',
    url: wwwApconCom.technologies.trafficShaping,
    category: 'optimize',
  },
  {
    id: 4,
    title: 'Pattern Matching',
    description:
      "APCON's Pattern Matching lets SecOps and NetOps filter traffic by packet contents, enhancing security and monitoring efficiency.",
    icon: 'mdi:variable',
    url: wwwApconCom.technologies.patternMatching,
    category: 'intel',
  },
  {
    id: 5,
    title: 'Packet Filtering',
    description: 'Blocks or allows network packets based on specific criteria.',
    icon: 'mdi:filter',
    url: wwwApconCom.technologies.networkPacketFiltering,
    category: 'intel',
  },
  {
    id: 6,
    title: 'Packet Slicing',
    description:
      'Divides packets into smaller segments to improve network efficiency and reduce latency.',
    icon: 'mdi:content-cut',
    url: wwwApconCom.technologies.packetSlicing,
    category: 'optimize',
  },
  {
    id: 7,
    title: 'Header Stripping',
    description:
      'Removes unnecessary headers from packets to reduce overhead and increase network speed.',
    icon: 'mdi:format-header-decrease',
    url: wwwApconCom.technologies.protocolHeaderStripping,
    category: 'optimize',
  },
  {
    id: 8,
    title: 'Network Data Deduplication',
    description:
      'Eliminates duplicate data packets to reduce network traffic and improve performance.',
    icon: 'heroicons:document-duplicate-20-solid',
    url: wwwApconCom.technologies.deduplication,
    category: 'optimize',
  },
  {
    id: 9,
    title: 'Tunneling',
    description:
      'Encapsulates data packets to ensure secure transmission across networks.',
    icon: 'mdi:tunnel',
    url: wwwApconCom.technologies.tunneling,
    category: 'optimize',
  },
  {
    id: 10,
    title: 'NetFlow Generation',
    description:
      'Offload processing from routers and other production equipment to increase efficiency and save costs. Consolidate NetFlow sources to reduce network traffic and simplify your monitoring architecture.',
    icon: 'mdi:view-grid-plus',
    url: wwwApconCom.technologies.netflowGeneration,
    category: 'intel',
  },
  {
    id: 11,
    title: 'Distributed Load Balancing',
    description:
      'Distributes network traffic across multiple paths to ensure efficient use of resources.',
    icon: 'mdi:server-network',
    url: wwwApconCom.technologies.distributedLoadBalance,
    category: 'optimize',
  },
  {
    id: 12,
    title: 'Application Analytics',
    description:
      'Provides insights into network application usage and performance.',
    icon: 'mdi:database',
    url: wwwApconCom.technologies.applicationAnalytics,
    category: 'intel',
  },
];

function getTechnologyByTitle(title) {
  return technologies.find(
    tech => tech.title.toLowerCase() === title.toLowerCase()
  );
}

function getTechnologiesByTitle(titles) {
  return technologies.filter(tech => titles.includes(tech.title));
}

function getTechnologyById(id) {
  return technologies.find(tech => tech.id === id);
}

function getTechnologiesByIds(ids) {
  return technologies.filter(tech => ids.includes(tech.id));
}

function getTechnologiesByCategory(category) {
  return technologies.filter(tech => tech.category === category);
}

export default technologies;
export {
  getTechnologiesByIds,
  getTechnologiesByCategory,
  getTechnologyById,
  getTechnologyByTitle,
  getTechnologiesByTitle,
};
